import React from "react";
import { HOW_IT_WORKS } from "../mock";
import { ArrowRight } from "lucide-react";

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-[#DC2626]">
            The workflow
          </span>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl font-700 tracking-tight text-[#0A2540]">
            Three steps to a build-ready plan
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            From a rough idea to a costed scope of work — no spreadsheets, no guesswork.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {HOW_IT_WORKS.map((s, i) => (
            <div
              key={s.step}
              className="group relative rounded-2xl border border-slate-200 bg-white p-8 hover:border-[#1D4ED8] hover:shadow-lg transition-all duration-300"
            >
              <div className="font-display text-5xl font-700 text-slate-100 group-hover:text-blue-100 transition-colors">
                {s.step}
              </div>
              <h3 className="mt-4 font-display text-xl font-600 text-[#0A2540]">
                {s.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
              {i < HOW_IT_WORKS.length - 1 && (
                <ArrowRight className="hidden md:block absolute top-1/2 -right-4 h-6 w-6 text-slate-300" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
